<template>
  <div class="handle-payment-bill">
      <div>
        <div class="d-flex flex-column">
            <p>Khách hàng: {{data.hoc_vien}}</p>
            <p>Tháng thanh toán: {{getMonthDeadPayment(data.thoi_han_tra)}}</p>
            <p>Số tiền cần thanh toán: {{data.so_tien_tra_gop | formatVND}}</p>
        </div>

        <div>
         <p>Đánh dấu đã nhận thanh toán</p>
          <el-select v-model="form.result" class="w-100" placeholder="Select">
            <el-option
                v-for="item in results"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="text-danger mt-4" style="font-weight: 600; word-break: auto-phrase">
          Lưu ý: Nếu đánh dấu đã xử lý hệ thống sẽ đánh dấu log đóng tiền này của khách hàng là đã thanh toán.
        </div>

        <div class="mt-4">
            <p>Nhập số tiền đã nhận <span class="text-danger">*</span></p>
            <el-input
                placeholder="Nhập số tiền đã nhận"
                :value="formatVND(form.amount)"
                @input="onAmountInput"
                clearable>
            </el-input>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <el-button @click="$emit('close')" size="small" style="background-color: #CACACA" class="rounded" >Hủy bỏ</el-button>
          <el-button @click="submit()" size="small" class="text-white rounded" style="background-color: #5D04B0" :loading="loading" :disabled="loading">Xác nhận</el-button>
        </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import {HANDLE_ERROR_PAYMENT} from "../../../../core/services/store/citime/citime.module";

export default {
  name: "dialog-handle-payment-bill",

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    is_show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading:false,
      form: {
        result: 'accept',
        amount: ''
      },
      results: [
        { value: 'accept', label: 'Đã nhận thanh toán' },
      ]
    };
  },

  computed: {


  },

  watch: {
    is_show: {
      handler(newVal) {
        if (!newVal) {
          this.form.amount = '';
        }
      },
      immediate: true
    }
  },

  methods: {
    getMonthDeadPayment(deadline) {
      if (!deadline) return '';

      const m = moment(deadline, [
        'DD/MM/YYYY',
        'DD/MM/YYYY HH:mm:ss',
        'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss',
        moment.ISO_8601
      ], true);

      return m.isValid() ? m.format('MM/YYYY') : '';
    },

    async submit() {
      const amount = this.form.amount;

      if (!amount) {
        return this.$notify({
          title: 'Thiếu dữ liệu!',
          message: 'Vui lòng nhập số tiền đã nhận!',
          type: 'warning'
        });
      }

      this.loading = true;

      try {
        const res = await this.$store.dispatch(HANDLE_ERROR_PAYMENT, {
          payment_id: this.data.id,
          amount
        });

        this.$notify({
          title: 'Success',
          message: res?.message || 'Xử lý lỗi thanh toán thành công!',
          type: 'success'
        });

        this.form.amount = '';
        this.$emit('close');
        this.$emit('reload');
      } catch (e) {
        this.$notify.error({
          title: 'Có lỗi xảy ra!',
          message: e?.data?.message || 'Xử lý lỗi thanh toán thất bại!'
        });
      } finally {
        this.loading = false;
      }
    },

    formatVND(val) {
      if (val === null || val === undefined || val === '') return '';
      const n = Number(String(val).replace(/\D/g, ''));
      if (!n) return '';
      return n.toLocaleString('vi-VN');
    },

    onAmountInput(value) {
      const raw = String(value || '').replace(/\D/g, '');
      this.form.amount = raw ? Number(raw) : '';
    },
  }
};
</script>

<style scoped>
    p {
      color: #282828;
    }
</style>